import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ReactHtmlParser from 'react-html-parser'
import { get, groupBy, map } from 'lodash'
import uniqid from 'uniqid'
import { formatDateLocalized, LocalizationContext } from '../utils'
import { withScroller } from '../utils/withScroller'

export type RatingsHistoryState = {
  selectedTabIndex: number
}
export type RatingsHistoryProps = {
  ratingId: string
  ratingEffectiveDate: string
  ratingCode: string
  ratingAlertCode: string
  ratingActionDescription: string
  ratingTypeDescription: string
  recoveryRatingValue: string
  correctionFlag: boolean
  changeDate: string
}

export type RatingsHistoryRowProps = {
  ratablesRatingHistory?: any[]
  children?: any
  row?: any
}

export type RatingsHistoryItemProps = {
  items: RatingsHistoryProps[]
}

const orderByRatingTypeDescription = (groupedByRatingTypeDescription: any) =>
  [...groupedByRatingTypeDescription]
    .sort((p) => {
      if (p.ratingTypeDescription.toLowerCase() === 'short term rating')
        return -1
      return 0
    })
    .sort((p) => {
      if (p.ratingTypeDescription.toLowerCase() === 'long term rating')
        return -1
      return 0
    })

export class RatingsHistory extends React.Component<
  RatingsHistoryRowProps,
  RatingsHistoryState
> {
  state = { selectedTabIndex: 0 }

  handleTabSelection = (tabIndex: number) => {
    this.setState({ selectedTabIndex: tabIndex })
  }

  render() {
    const { children, ratablesRatingHistory = [], row = {} } = this.props
    const { selectedTabIndex } = this.state
    const { original } = row
    const rowOriginaldata = original ? original.ratablesRatingHistory : []
    const ratablesRatingHistoryData =
      ratablesRatingHistory && ratablesRatingHistory.length
        ? ratablesRatingHistory
        : rowOriginaldata

    ratablesRatingHistoryData.sort(
      (a: RatingsHistoryProps, b: RatingsHistoryProps) => {
        if (a.ratingEffectiveDate > b.ratingEffectiveDate) return -1
        if (a.ratingEffectiveDate < b.ratingEffectiveDate) return 1
        return 0
      }
    )
    const groupedByRatingTypeDescription = map(
      groupBy(ratablesRatingHistoryData, 'ratingTypeDescription'),
      (value, key) => ({ ratingTypeDescription: key, ratings: value })
    )

    // RWR-2746 (order by LTR, STR and rest)
    const orderByLTR = orderByRatingTypeDescription(
      groupedByRatingTypeDescription
    )

    const tabs: any[] = []
    const tabPanels: any[] = []
    orderByLTR.forEach((ratingTypeDescription) => {
      tabs.push(
        <Tab key={uniqid()}>{ratingTypeDescription.ratingTypeDescription}</Tab>
      )
      const ratings: RatingsHistoryProps[] = get(
        ratingTypeDescription,
        'ratings',
        []
      )
      tabPanels.push(
        <TabPanel key={uniqid()}>
          <div className="table table--2">
            <div className="table__overflow">
              {withScroller(
                <LocalizationContext.Consumer>
                  {({ language }) => (
                    <table
                      className="table__wrapper"
                      style={{ width: '100%', minWidth: 'auto' }}
                    >
                      <tbody>
                        <tr>
                          {children ? (
                            <td style={{ verticalAlign: 'top' }}>{children}</td>
                          ) : null}
                          {ratings.map((item) => (
                            <td key={uniqid()} style={{ verticalAlign: 'top' }}>
                              {formatDateLocalized(
                                item.ratingEffectiveDate,
                                'MMM dd yyyy',
                                language
                              )}
                              <br />
                              {item.ratingCode}
                              {ReactHtmlParser(
                                item.ratingAlertCode
                                  ? `<span class=${item.ratingAlertCode.replace(
                                      ':',
                                      ''
                                    )}></span>`
                                  : ''
                              )}
                              <br />
                              {item.ratingActionDescription}
                              {item.correctionFlag
                                ? ReactHtmlParser(
                                    `<br />Rating Correction
                                <br />
                                (${formatDateLocalized(
                                  item.changeDate,
                                  'MMM dd yyyy',
                                  language
                                )})`
                                  )
                                : null}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  )}
                </LocalizationContext.Consumer>
              )}
            </div>
          </div>
        </TabPanel>
      )
    })
    return (
      <Tabs
        selectedTabClassName={
          tabs.length === 1 ? 'react-tabs__tab--heading' : ''
        }
        selectedIndex={selectedTabIndex}
        onSelect={(index) => this.handleTabSelection(index)}
      >
        <TabList>{tabs}</TabList>
        {tabPanels}
      </Tabs>
    )
  }
}
